import { FlatBorderCard } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemDetailsSourceRowStyled = styled(FlatBorderCard)`
  display: flex;
  border-color: ${(props) => props.theme.colors.content.secondaryBorder};
  align-items: center;
  justify-content: space-between;
  gap: ${(props) => props.theme.space.small};
  width: 100%;
  padding: ${(props) => props.theme.space.medium};
`
